import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
const MyPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f8f9fa',
          100: '#e9ecef',
          200: '#dee2e6',
          300: '#ced4da',
          400: '#adb5bd',
          500: '#6c757d',
          600: '#495057',
          700: '#343a40',
          800: '#212529',
          900: '#121416',
          950: '#0b0d0e',
        },
        primary: {
          50: '#E3E5F6',
          100: '#C7CBED',
          200: '#A3A7E1',
          300: '#7E83D4',
          400: '#6067C7',
          500: '#2C3689',
          600: '#262F7A',
          700: '#1F2769',
          800: '#181F58',
          900: '#111746',
          950: '#0B1036',
        },
      },
      dark: {
        primary: {
          50: '#DDE0F4',
          100: '#B6BBE9',
          200: '#8D94DB',
          300: '#666ECF',
          400: '#505AC2',
          500: '#3D469C',
          600: '#323A85',
          700: '#272F6E',
          800: '#1D2358',
          900: '#151A42',
          950: '#0E1230',
        },
      },
    },
  },
});

export { MyPreset };
